import { Box, Button } from "@mui/material";
import confetti from "canvas-confetti";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import env from "shared/config/env";
import { randomA } from "shared/palettes";
import DiceDisplay from "./components/DiceDisplay";
import GameHeader from "./components/GameHeader";
import JoinRoom from "./components/JoinRoom";
import ResultsBoard from "./components/ResultsBoard";
import useGameSocket from "./hooks/useGameSocket";
import { ContainerStyle } from "./styled";

export default (props) => {
  const { duration } = props;
  const randomNames = randomA;
  const [userName, setUserName] = useState(
    () => randomNames[Math.floor(Math.random() * randomNames.length)]
  );
  const [inputCode, setInputCode] = useState(env.defaultRoomCode);

  // Initialize the custom hook
  const {
    isJoined,
    players, // Used in logical extensions if needed, or we can pass to a player list component
    myNumbers,
    allPlayersData,
    hasRolled,
    isRolling,
    socketRef,
    joinRoom,
    exitRoom,
    rollDice,
    revealAll,
    resetRoom,
  } = useGameSocket(inputCode, userName, inputCode); // roomCode is same as inputCode in this logic

  // Confetti Effect
  const runConfetti = () => {
    const duration = 2000;
    const animationEnd = Date.now() + duration;
    const defaults = {
      startVelocity: 30,
      spread: 360,
      ticks: 60,
      zIndex: 0,
    };

    const randomInRange = (min, max) => Math.random() * (max - min) + min;

    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 650 * (timeLeft / duration);
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
      });
      confetti({
        ...defaults,
        particleCount,
        origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
      });
    }, 250);
  };

  // Trigger confetti when results are revealed
  useEffect(() => {
    if (allPlayersData) {
      runConfetti();
    }
  }, [allPlayersData]);

  const handleJoinRoom = () => {
    if (inputCode) {
      joinRoom();
    }
  };

  if (!isJoined) {
    return (
      <motion.div
        initial={{ x: -10, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: 10, opacity: 0 }}
        transition={{ duration: duration }}
      >
        <JoinRoom
          inputCode={inputCode}
          setInputCode={setInputCode}
          userName={userName}
          setUserName={setUserName}
          handleJoinRoom={handleJoinRoom}
        />{" "}
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ x: -10, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: 10, opacity: 0 }}
      transition={{ duration: duration }}
    >
      <ContainerStyle
        style={{ justifyContent: "unset" }}
        sx={{ pt: 2, pb: 5, minHeight: "100vh" }}
      >
        {/* --- Header --- */}
        <GameHeader roomCode={inputCode} userName={userName} />

        {/* Actions */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { sm: "row" },
            gap: 2,
            mb: 4,
            px: 1,
          }}
        >
          <Button
            variant="contained"
            fullWidth
            onClick={revealAll}
            sx={{ py: 1.5 }}
          >
            OPEN ALL (เฉลย)
          </Button>
          <Button
            variant="contained"
            color="error"
            fullWidth
            onClick={resetRoom}
          >
            RESET ROOM
          </Button>
        </Box>

        {/* Main Game Area */}
        <DiceDisplay
          myNumbers={myNumbers}
          isRolling={isRolling}
          hasRolled={hasRolled}
          handleRollDice={rollDice}
          setAllPlayersData={() => {}} // No-op since hook handles state, but button might clear it logic? Hook clears it on roll.
        />

        {/* Results List */}
        <ResultsBoard
          allPlayersData={allPlayersData}
          currentSocketId={socketRef.current?.id}
        />
      </ContainerStyle>
    </motion.div>
  );
};
